import {EnumDisponibilidadeProduto} from '../../lib/emun/EnumDisponibilidadeProduto';

export function adicionalEstaOculto(valor: any): boolean {
  if(ArrayBuffer.isView(valor)) return (valor as any).length === 1 && (valor as any)[0] !== 0;
  if(valor?.type === 'Buffer' && Array.isArray(valor.data)) return valor.data.length === 1 && valor.data[0] !== 0;
  return valor === true || valor === 1 || valor === '1' || valor === 'true';
}

export function produtoEstaOculto(produto: any): boolean {
  const disponibilidade = produto?.catalogo?.disponibilidadePorEmpresa
    ? produto?.produtoNaEmpresa?.disponibilidade ?? produto?.disponibilidade
    : produto?.disponibilidade;
  return Number(disponibilidade) === EnumDisponibilidadeProduto.Oculto;
}

export function opcoesVisiveisNoCadastro(produto: any, opcoes: any[]): any[] {
  return (opcoes || []).filter(opcao => produtoEstaOculto(produto) || !adicionalEstaOculto(opcao?.oculta));
}
